import { render } from "./ConfirmationOverlay.vue?vue&type=template&id=60bbca48"
import script from "./ConfirmationOverlay.vue?vue&type=script&lang=js"
export * from "./ConfirmationOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/evoove-zcd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__